import EarthSectionBase from "./EarthSectionBase";
import floor from "../../images/assets/space/SPACE_FLOOR_01.svg";
import bot_floor from "../../images/assets/space/SPACE2_TOP_FLOOR.svg";
import swirl from "../../images/assets/space/SPACE2_SWIRL.svg";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import coin from "../../images/assets/shared/R_COIN.svg";
import StarField from "../shared/StarField";
import CollectibleCoin, { getRandomCoinHover } from "../shared/CollectibleCoin";

export default function Space2({
                                   layer,
                                   collectedCoinIds = [],
                                   onCoinCollect
}){
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover(), getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "space2-coin-1", className: "space2-coin", style: coinStyles[0] },
        { id: "space2-coin-2", className: "space2-coin2", style: coinStyles[1] },
    ]

    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={"earth-hero earth-section-space"}
        >
            <img src={floor} alt="" className={'background-img space2-floor tile'} />
            <img src={bot_floor} alt="" className={'background-img space2-bot-floor tile'} />
            <img src={swirl} alt="" className={'background-img space2-swirl'} />

            <StarField/>

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <p className={'about-me-text'}>{t('AboutMeParagraph')}</p>
        </EarthSectionBase>
    )
}